import { UploadElementType } from "@custom-types/file-upload-types";
import { isTaskCompleted, isTaskInProgress } from "@hooks/upload-tasks/upload-tasks-utils";
import { createSelector } from "@reduxjs/toolkit";
import { uploadTasksAdapter } from "@store/upload-tasks/upload-tasks-slice";

/** @returns List of all upload tasks */
export const uploadTasksSelector = createSelector(state => state.uploadTasks, uploadTasks => {
  const tasks = uploadTasksAdapter.getSelectors().selectAll(uploadTasks);
  return tasks;
});

/** @returns  An upload task */
export function uploadTaskByIdSelector(id) {
  return createSelector(state => state.uploadTasks, uploadTasks => {
    const uploadTask = uploadTasksAdapter.getSelectors().selectById(uploadTasks, id);
    return uploadTask;
  });
}

/** @returns List of all incomplete upload tasks */
const incompleteUploadTasksSelector = createSelector(uploadTasksSelector, tasks => {
  const incompleteUploadTasks = tasks.filter(task => !isTaskCompleted(task));
  return incompleteUploadTasks;
});

/** @returns True if any incomplete tasks is available in the store */
export const hasIncompleteUploadTasksSelector = createSelector(incompleteUploadTasksSelector, incompleteUploadTasks => {
  return !!incompleteUploadTasks.length;
});

/** @returns True if any in-progress tasks is available in the store */
export const hasInProgressUploadTasksSelector = createSelector(uploadTasksSelector, tasks => {
  return tasks.some(isTaskInProgress);
});

/** @returns List of incomplete attachment upload tasks for a given markup */
export function incompleteMarkupAttachmentUploadTasksSelector(iElementId) {
  return createSelector(incompleteUploadTasksSelector, incompleteTasks => {
    const markupAttachmentUploadTasks = incompleteTasks.filter(task => task.context.uploadElementType === UploadElementType.annotation && task.context.iElementId === iElementId);
    return markupAttachmentUploadTasks;
  });
}